import { ReactElement, forwardRef } from 'react';
import { SvgIconProps, SvgIcon } from '@mui/material';

const QrCodeIcon = forwardRef<SVGSVGElement, SvgIconProps>(function QrCodeIcon(
  inProps,
  ref,
): ReactElement {
  return (
    <SvgIcon ref={ref} viewBox="0 0 229.7 229.7" {...inProps}>
      <g>
        <g>
          <rect x="126.34" y="126.34" width="103.37" height="21.86" />
          <rect x="160.79" y="160.79" width="34.46" height="34.46" />
          <rect x="126.34" y="195.25" width="34.46" height="34.46" />
          <rect x="195.25" y="195.25" width="34.46" height="34.46" />
          <path d="m0,0v103.37h103.37V0H0Zm88.55,88.55H14.82V14.82h73.73v73.73Z" />
          <rect x="34.46" y="34.46" width="34.46" height="34.46" />
          <path d="m0,126.34v103.37h103.37v-103.37H0Zm88.55,88.92H14.82v-74.47h73.73v74.47Z" />
          <rect x="34.46" y="160.79" width="34.46" height="34.46" />
          <path d="m126.34,0v103.37h103.37V0h-103.37Zm88.92,88.55h-74.47V14.82h74.47v73.73Z" />
          <rect x="160.79" y="34.46" width="34.46" height="34.46" />
        </g>
      </g>
    </SvgIcon>
  );
});

export default QrCodeIcon;
